import React, { useEffect, useState } from 'react';
import { Button, Icon } from 'antd';
import { useHistory } from 'react-router-dom';
import { UserRating } from '../../services/api';
import { PageRoute } from '../../models';
import { useSelector } from 'react-redux';
import { selectUserInfo } from '../../routes/Auth/auth.ducks';
import { checkEmptyObject } from '../../services';
import ReactGA from "react-ga4";
import styles from './ratingButton.scss';

interface RatingButtonProps {
  user: any;
  adId?: number;
  chatId?: string;
  className?: string;
  gaLabel?: string;
}

const RatingButton = ({
  user,
  adId,
  className,
  chatId,
  gaLabel
}: RatingButtonProps) => {
  const history = useHistory();
  const [eligibilityAds, setEligibilityAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const userInfo = useSelector(selectUserInfo);

  useEffect(() => {
    const fetchEligibility = async () => {
      try {
        setLoading(true);
        const response = await UserRating.getRatingEligibilityAds(user.id || user.userId);
        setEligibilityAds(response);
      } catch (error) {
        console.error('Error fetching rating eligibility:', error);
        setEligibilityAds([]);
      } finally {
        setLoading(false);
      }
    };

    if (
      checkEmptyObject(user) &&
      (user.id || user.userId) &&
      checkEmptyObject(userInfo)
    ) {
      fetchEligibility();
    } else {
      setEligibilityAds([]);
      setLoading(false);
    }
  }, [user, userInfo]);


  const handleRatingClick = () => {
    if (gaLabel) {
      ReactGA.event({
        category: "Ocjene",
        action: "Click",
        label: gaLabel
      });
    }

    // Get username from user object
    const username = user.username || user.name;

    // Capture current URL to return after rating
    const returnUrl = history.location.pathname + history.location.search;

    // If adId is provided, navigate to ratings page with that ad preselected
    if (username && adId !== undefined) {
      history.push({
        pathname: `${PageRoute.user}/${encodeURIComponent(username)}${PageRoute.userRatings}`,
        state: {
          openRatingModal: true,
          preselectedAdId: adId,
          returnUrl,
        }
      });
    }

    // If chatId is provided, navigate to ratings page with that chat preselected
    if ((username && chatId !== undefined)) {
      history.push({
        pathname: `${PageRoute.user}/${encodeURIComponent(username)}${PageRoute.userRatings}`,
        state: {
          openRatingModal: true,
          preselectedChatId: chatId,
          returnUrl,
        }
      });
    }

    // Otherwise, just open the ratings page
    if (username && adId === undefined && chatId === undefined) {
      history.push({
        pathname: `${PageRoute.user}/${encodeURIComponent(username)}${PageRoute.userRatings}`,
        state: {
          openRatingModal: true,
          returnUrl,
        }
      });
    }
  };

  // Don't show anything while loading
  if (loading) {
    return null;
  }

  // If user has eligible ads, show the rating button
  if (eligibilityAds.length > 0) {
    return (
      <Button
        onClick={handleRatingClick}
        className={`${styles.ratingButton} ${className || ''}`}
      >
        <Icon type="star" theme="filled" className={styles.starIcon} />
        Ocijeni korisnika
      </Button>
    );
  }

  // Otherwise, return null
  return null;
};

export default RatingButton;



// WEBPACK FOOTER //
// ./src/components/RatingButton/index.tsx